import { supabase } from '../supabaseClient';

// Invitaciones pendientes para el usuario actual.
// RPC SECURITY DEFINER (no un select directo): la RLS de torneos no deja al
// club invitado leer el torneo (solo la organizadora), asi que el embed
// `torneos(...)` volveria null. get_mis_invitaciones_torneo() filtra por el
// email del JWT y devuelve las columnas del torneo ya aplanadas.
export async function getMisInvitacionesTorneo() {
  const { data, error } = await supabase.rpc('get_mis_invitaciones_torneo');
  return { data: data || [], error };
}

// Aceptar/rechazar via RPC SECURITY DEFINER: club_org_id se deriva server-side de la
// membresia activa del llamador (no del cliente) - ver 20260727c_invitacion_rpcs_hardening.sql.
export async function aceptarInvitacion(id) {
  return supabase.rpc('aceptar_invitacion_torneo', { p_id: id });
}

export async function rechazarInvitacion(id) {
  return supabase.rpc('rechazar_invitacion_torneo', { p_id: id });
}

// Torneos donde el club tiene licencia (invitacion aceptada), para llegar a inscribir grupos.
// RPC SECURITY DEFINER: la RLS de torneos no deja al club leer el torneo de la organizadora.
export async function getMisTorneosConLicencia() {
  const { data, error } = await supabase.rpc('get_mis_torneos_con_licencia');
  return { data: data || [], error };
}
